/* Picks Shop — interacciones del diseño Stitch (Curated Minimal Luxe) */
(function () {
  'use strict';
  var PS = window.PicksShop || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Utilidades ---------- */
  function formatMoney(cents) {
    var value = (Number(cents) / 100).toFixed(2);
    var fmt = PS.moneyFormat || '${{amount}}';
    var withComma = value.replace('.', ',');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, Number(value).toLocaleString('en-US', { minimumFractionDigits: 2 }))
      .replace(/<[^>]*>/g, '');
  }
  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function rootUrl(path) {
    var root = (PS.routes && PS.routes.root) || '/';
    return (root.replace(/\/$/, '') + path);
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function showToast(message) {
    var toast = $('#toast-notification');
    if (!toast) return;
    $('#toast-text').textContent = message;
    toast.classList.remove('translate-y-20', 'opacity-0');
    toast.classList.add('translate-y-0', 'opacity-100');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('translate-y-0', 'opacity-100');
      toast.classList.add('translate-y-20', 'opacity-0');
    }, 2600);
  }
  PS.showToast = showToast;

  /* ---------- Contador de la bolsa ---------- */
  function setCartCount(count) {
    $$('[data-ps-cart-count]').forEach(function (badge) {
      badge.textContent = count;
      badge.classList.toggle('hidden', !count);
      badge.classList.add('scale-125');
      setTimeout(function () { badge.classList.remove('scale-125'); }, 300);
    });
  }
  function refreshCartCount() {
    return fetch(rootUrl('/cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); return cart; });
  }

  function addToCart(variantId, quantity) {
    return fetch(rootUrl('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity || 1) }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'No se pudo añadir');
        return data;
      });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = $$('.reveal-on-scroll:not(.is-revealed)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-revealed'); }); return; }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); obs.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0.12 });
    els.forEach(function (el) {
      var parent = el.parentElement;
      if (parent && parent.children.length > 1) {
        var i = Array.prototype.indexOf.call(parent.children, el);
        el.style.transitionDelay = Math.min(i * 80, 400) + 'ms';
      }
      io.observe(el);
    });
  }

  /* ---------- Menú móvil ---------- */
  function initMobileMenu() {
    var btn = $('[data-ps-menu-toggle]');
    var menu = $('[data-ps-mobile-menu]');
    if (!btn || !menu) return;
    btn.addEventListener('click', function () {
      var open = menu.classList.toggle('hidden') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.querySelector('.material-symbols-outlined').textContent = open ? 'close' : 'menu';
    });
  }

  /* ---------- Filtros (pills, búsqueda, orden, vista) ---------- */
  var PILL_ACTIVE = ['bg-negro-picks', 'text-blanco', 'active-pill', 'shadow-sm', 'font-bold', 'border-negro-picks'];
  function setPill(btn, active) {
    var dark = btn.getAttribute('data-ps-pill-style') === 'dark';
    var keep = btn.hasAttribute('data-ps-keep-color');
    var inactive = dark ? ['bg-[#111d27]', 'text-[#8E9AA8]'] : (keep ? ['bg-marfil', 'text-naranja-acento'] : ['bg-marfil', 'text-piedra', 'border-border-subtle']);
    if (active) { inactive.forEach(function (c) { btn.classList.remove(c); }); PILL_ACTIVE.forEach(function (c) { btn.classList.add(c); }); btn.setAttribute('aria-selected', 'true'); }
    else { PILL_ACTIVE.forEach(function (c) { btn.classList.remove(c); }); inactive.forEach(function (c) { btn.classList.add(c); }); btn.setAttribute('aria-selected', 'false'); }
  }

  function initFilterScope(scope) {
    var grid = $('[data-ps-grid]', scope);
    if (!grid) return;
    var items = function () { return $$('.product-item', grid); };
    var pills = $$('[data-ps-cat]', scope);
    var search = $('[data-ps-search]', scope);
    var sort = $('[data-ps-sort]', scope);
    var counter = $('[data-ps-counter]', scope);
    var status = $('[data-ps-status]', scope);
    var statusText = $('[data-ps-status-text]', scope);
    var empty = $('[data-ps-empty]', scope);
    var current = 'all';
    var originalOrder = items();

    // conteos por categoría
    var counts = { all: originalOrder.length };
    originalOrder.forEach(function (it) {
      (it.getAttribute('data-category') || '').split(' ').forEach(function (c) { if (c) counts[c] = (counts[c] || 0) + 1; });
    });
    $$('[data-ps-count]', scope).forEach(function (el) {
      var k = el.getAttribute('data-ps-count');
      el.textContent = '(' + (counts[k] || 0) + ')';
    });

    function apply() {
      var term = search ? search.value.toLowerCase().trim() : '';
      var visible = 0;
      items().forEach(function (it) {
        var cats = (it.getAttribute('data-category') || '').toLowerCase().split(' ');
        var name = (it.getAttribute('data-name') || '').toLowerCase();
        var ok = (current === 'all' || cats.indexOf(current) > -1) && (!term || name.indexOf(term) > -1);
        it.classList.toggle('hidden', !ok);
        if (ok) { visible++; it.classList.add('is-revealed'); }
      });
      if (counter && (current !== 'all' || term)) counter.textContent = visible;
      else if (counter && counter.dataset.total) counter.textContent = counter.dataset.total;
      if (empty) { empty.classList.toggle('hidden', visible > 0); empty.classList.toggle('flex', visible === 0); }
      if (status) {
        var filtering = current !== 'all' || term;
        status.classList.toggle('hidden', !filtering);
        status.classList.toggle('flex', !!filtering);
        if (statusText && filtering) {
          var label = current === 'all' ? 'Todas las piezas' : current.replace(/-/g, ' ');
          statusText.innerHTML = 'Mostrando: <strong class="text-negro-picks uppercase">' + escapeHtml(label) + '</strong> ' + (term ? '· "' + escapeHtml(term) + '" ' : '') + '(' + visible + ')';
        }
      }
    }
    if (counter) counter.dataset.total = counter.textContent;

    pills.forEach(function (btn) {
      btn.addEventListener('click', function () {
        pills.forEach(function (b) { setPill(b, false); });
        setPill(btn, true);
        current = btn.getAttribute('data-ps-cat');
        apply();
      });
    });
    if (search) search.addEventListener('input', apply);
    $$('[data-ps-reset]', scope).forEach(function (b) {
      b.addEventListener('click', function () {
        if (search) search.value = '';
        var all = $('[data-ps-cat="all"]', scope);
        if (all) all.click(); else { current = 'all'; apply(); }
      });
    });
    if (sort) {
      sort.addEventListener('change', function () {
        var v = sort.value;
        var arr = originalOrder.slice();
        if (v !== 'featured') {
          arr.sort(function (a, b) {
            var pa = parseFloat(a.dataset.price), pb = parseFloat(b.dataset.price);
            if (v === 'price-asc') return pa - pb;
            if (v === 'price-desc') return pb - pa;
            if (v === 'newest') return Number(b.dataset.created) - Number(a.dataset.created);
            return 0;
          });
        }
        arr.forEach(function (it) { grid.appendChild(it); });
      });
    }
    var views = $$('[data-ps-view]', scope);
    var gridMap = {
      '3': 'grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-6 transition-all duration-300',
      '4': 'grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-6 transition-all duration-300',
      '2': 'grid grid-cols-1 md:grid-cols-2 gap-8 transition-all duration-300'
    };
    views.forEach(function (btn) {
      btn.addEventListener('click', function () {
        views.forEach(function (b) { b.classList.remove('text-negro-picks', 'bg-blanco', 'shadow-sm'); b.classList.add('text-piedra'); });
        btn.classList.add('text-negro-picks', 'bg-blanco', 'shadow-sm'); btn.classList.remove('text-piedra');
        grid.className = gridMap[btn.getAttribute('data-ps-view')];
      });
    });
  }

  /* ---------- Favoritos (guardados en el navegador) ---------- */
  var FAV_KEY = 'ps-favoritos';
  function getFavs() { try { return JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); } catch (e) { return []; } }
  function saveFavs(list) { try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) {} updateFavUI(); }
  function updateFavUI() {
    var favs = getFavs();
    $$('[data-ps-fav]').forEach(function (btn) {
      var on = favs.indexOf(btn.getAttribute('data-ps-fav')) > -1;
      var icon = btn.querySelector('.material-symbols-outlined');
      if (icon) icon.classList.toggle('icon-filled', on);
      if (!btn.hasAttribute('data-ps-fav-remove-line')) {
        btn.classList.toggle('text-naranja-acento', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    });
    $$('[data-ps-fav-count]').forEach(function (el) { el.textContent = favs.length; el.classList.toggle('hidden', !favs.length); });
  }
  function initFavorites() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ps-fav]');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      var handle = btn.getAttribute('data-ps-fav');
      var favs = getFavs();
      var idx = favs.indexOf(handle);
      var removeLine = btn.getAttribute('data-ps-fav-remove-line');
      if (removeLine) {
        if (idx === -1) favs.push(handle);
        saveFavs(favs);
        window.location.href = rootUrl('/cart/change?line=' + removeLine + '&quantity=0');
        return;
      }
      var icon = btn.querySelector('.material-symbols-outlined');
      if (icon) { icon.classList.add('heart-pop'); setTimeout(function () { icon.classList.remove('heart-pop'); }, 280); }
      if (idx > -1) { favs.splice(idx, 1); showToast('Eliminado de tus Favoritos'); }
      else { favs.push(handle); showToast('Guardado en tus Favoritos'); }
      saveFavs(favs);
      if (btn.closest('[data-ps-favorites-page]') && idx > -1) renderFavoritesPage();
    });
    updateFavUI();
    renderFavoritesPage();
  }
  function favCard(p) {
    var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=700' : '';
    var sale = p.compare_at_price > p.price;
    return '<article class="product-item group relative bg-blanco ' + (sale ? 'border-2 border-naranja-acento' : 'border border-border-strong') + ' flex flex-col justify-between transition-all duration-300 hover:shadow-lg">' +
      '<div class="relative aspect-[4/5] w-full overflow-hidden bg-marfil">' +
      '<button type="button" aria-label="Quitar de favoritos" data-ps-fav="' + escapeHtml(p.handle) + '" class="fav-btn absolute top-3 right-3 z-10 w-8 h-8 rounded-full bg-blanco/90 backdrop-blur text-naranja-acento flex items-center justify-center border border-border-subtle shadow-sm"><span class="material-symbols-outlined text-sm icon-filled">favorite</span></button>' +
      '<a href="' + escapeHtml(p.url) + '" class="block w-full h-full">' + (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy">' : '') + '</a></div>' +
      '<div class="p-4 flex flex-col gap-1.5 flex-1 justify-between bg-blanco"><div><div class="text-piedra text-label-sm font-label-sm uppercase tracking-widest mb-1 font-semibold">' + escapeHtml(p.type || 'Picks Shop') + '</div>' +
      '<h3 class="font-headline-sm text-headline-sm text-negro-picks leading-snug line-clamp-1"><a href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a></h3></div>' +
      '<div class="pt-2 flex items-baseline gap-2 border-t border-border-subtle mt-3"><span class="font-price-display text-price-display ' + (sale ? 'text-naranja-acento' : 'text-negro-picks') + ' tabular-nums font-semibold">' + formatMoney(p.price) + '</span>' +
      (sale ? '<span class="text-xs line-through text-piedra font-price-display tabular-nums">' + formatMoney(p.compare_at_price) + '</span>' : '') + '</div></div></article>';
  }
  function renderFavoritesPage() {
    var page = $('[data-ps-favorites-page]');
    if (!page) return;
    var grid = $('[data-ps-favorites-grid]', page);
    var empty = $('[data-ps-favorites-empty]', page);
    var favs = getFavs();
    if (!favs.length) { grid.innerHTML = ''; empty.classList.remove('hidden'); empty.classList.add('flex'); return; }
    empty.classList.add('hidden'); empty.classList.remove('flex');
    Promise.all(favs.map(function (h) {
      return fetch(rootUrl('/products/' + encodeURIComponent(h) + '.js')).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      var valid = list.filter(Boolean);
      grid.innerHTML = valid.map(favCard).join('');
      if (!valid.length) { empty.classList.remove('hidden'); empty.classList.add('flex'); }
      updateFavUI();
    });
  }

  /* ---------- Añadir a la bolsa (botones rápidos) ---------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ps-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.dataset.busy) return;
      btn.dataset.busy = '1';
      var textSpan = btn.querySelector('.btn-text');
      var original = textSpan ? textSpan.textContent : null;
      addToCart(btn.getAttribute('data-ps-add'), 1).then(function () {
        if (btn.hasAttribute('data-ps-reload')) { window.location.reload(); return; }
        if (textSpan) { textSpan.textContent = '✓ Listo'; }
        btn.classList.add('bg-naranja-acento', 'text-blanco');
        showToast('Añadido: ' + (btn.getAttribute('data-ps-name') || 'pieza'));
        refreshCartCount();
        setTimeout(function () {
          if (textSpan) textSpan.textContent = original;
          btn.classList.remove('bg-naranja-acento');
          delete btn.dataset.busy;
        }, 1600);
      }).catch(function (err) {
        showToast(err.message);
        delete btn.dataset.busy;
      });
    });
  }

  /* ---------- Vista rápida ---------- */
  var qv = { product: null, variant: null };
  function openQuickView(handle) {
    var modal = $('#quickview-modal');
    if (!modal) return;
    fetch(rootUrl('/products/' + encodeURIComponent(handle) + '.js')).then(function (r) { return r.json(); }).then(function (p) {
      qv.product = p;
      qv.variant = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=900' : '';
      $('#qv-image').src = img; $('#qv-image').alt = p.title;
      $('#qv-title').textContent = p.title;
      $('#qv-category').textContent = (p.type || 'Picks Shop');
      var tmp = document.createElement('div'); tmp.innerHTML = p.description || '';
      $('#qv-description').textContent = (tmp.textContent || '').trim();
      var badge = '';
      (p.tags || []).forEach(function (t) { if (/^badge:/i.test(t)) badge = t.split(':').slice(1).join(':').trim(); });
      $('#qv-tag').textContent = badge || (p.available ? 'Auténtico' : 'Agotado');
      $('#qv-link').href = p.url;
      var sel = $('#qv-size-selector');
      var wrap = $('#qv-options-wrap');
      sel.innerHTML = '';
      if (p.variants.length > 1) {
        wrap.classList.remove('hidden');
        p.variants.forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button';
          b.textContent = v.title;
          b.disabled = !v.available;
          b.className = 'qv-size-btn px-3.5 py-1.5 border text-xs font-label-sm uppercase disabled:opacity-30 disabled:line-through ' + (v.id === qv.variant.id ? 'border-negro-picks text-negro-picks bg-marfil font-bold' : 'border-border-strong text-piedra hover:text-negro-picks');
          b.addEventListener('click', function () {
            qv.variant = v;
            $$('.qv-size-btn', sel).forEach(function (x) { x.classList.remove('border-negro-picks', 'text-negro-picks', 'bg-marfil', 'font-bold'); x.classList.add('border-border-strong', 'text-piedra'); });
            b.classList.add('border-negro-picks', 'text-negro-picks', 'bg-marfil', 'font-bold'); b.classList.remove('border-border-strong', 'text-piedra');
            updateQvPrice();
          });
          sel.appendChild(b);
        });
      } else { wrap.classList.add('hidden'); }
      updateQvPrice();
      modal.classList.remove('opacity-0', 'pointer-events-none');
      modal.classList.add('opacity-100', 'pointer-events-auto');
      modal.setAttribute('aria-hidden', 'false');
      $('#quickview-panel').classList.remove('scale-95'); $('#quickview-panel').classList.add('scale-100');
      document.body.classList.add('overflow-hidden');
      setTimeout(function () { var c = $('[data-ps-qv-close]'); if (c) c.focus(); }, 50);
    });
  }
  function updateQvPrice() {
    var v = qv.variant; if (!v) return;
    $('#qv-price').textContent = formatMoney(v.price);
    var cmp = $('#qv-compare');
    if (v.compare_at_price > v.price) { cmp.textContent = formatMoney(v.compare_at_price); cmp.classList.remove('hidden'); }
    else cmp.classList.add('hidden');
    var add = $('#qv-add-btn');
    add.disabled = !v.available;
    $('#qv-add-text').textContent = v.available ? 'Añadir al Carrito' : 'Agotado';
  }
  function closeQuickView() {
    var modal = $('#quickview-modal');
    if (!modal) return;
    modal.classList.add('opacity-0', 'pointer-events-none');
    modal.classList.remove('opacity-100', 'pointer-events-auto');
    modal.setAttribute('aria-hidden', 'true');
    $('#quickview-panel').classList.add('scale-95'); $('#quickview-panel').classList.remove('scale-100');
    document.body.classList.remove('overflow-hidden');
  }
  function initQuickView() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ps-quickview]');
      if (btn) { e.preventDefault(); openQuickView(btn.getAttribute('data-ps-quickview')); return; }
      if (e.target.closest('[data-ps-qv-close]') || e.target.id === 'quickview-modal') closeQuickView();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuickView(); });
    var add = $('#qv-add-btn');
    if (add) add.addEventListener('click', function () {
      if (!qv.variant) return;
      addToCart(qv.variant.id, 1).then(function () {
        showToast('Añadido: ' + qv.product.title + ' (' + formatMoney(qv.variant.price) + ')');
        refreshCartCount();
        closeQuickView();
      }).catch(function (err) { showToast(err.message); });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProduct() {
    var root = $('[data-ps-product]');
    if (!root) return;
    var jsonEl = $('[data-ps-product-json]', root);
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var form = $('[data-ps-product-form]', root) || $('#ProductForm');
    var idInput = $('[data-ps-variant-id]', root);
    var priceEl = $('[data-ps-price]', root);
    var compareEl = $('[data-ps-compare]', root);
    var submit = $('[data-ps-submit]', root);
    var submitText = $('[data-ps-submit-text]', root);
    var mainMedia = $('[data-ps-main-media]', root);

    function setMain(src) {
      var img = mainMedia && mainMedia.querySelector('img');
      if (img && src) { img.srcset = ''; img.src = src; }
    }
    $$('[data-ps-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () {
        setMain(t.getAttribute('data-ps-thumb'));
        $$('[data-ps-thumb]', root).forEach(function (x) { x.classList.remove('border-negro-picks'); x.classList.add('border-border-subtle'); });
        t.classList.add('border-negro-picks'); t.classList.remove('border-border-subtle');
      });
    });

    $$('[data-ps-option]', root).forEach(function (input) {
      input.addEventListener('change', function () {
        if (!product) return;
        var selected = [];
        $$('[data-ps-option]:checked', root).forEach(function (i) { selected[Number(i.getAttribute('data-ps-option'))] = i.value; });
        var label = $('[data-ps-option-label="' + input.getAttribute('data-ps-option') + '"]', root);
        if (label) label.textContent = input.value;
        var variant = product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); })[0];
        if (!variant) { submit.disabled = true; submitText.textContent = 'No disponible'; return; }
        idInput.value = variant.id;
        priceEl.textContent = formatMoney(variant.price);
        var sale = variant.compare_at_price > variant.price;
        priceEl.classList.toggle('text-naranja-acento', sale); priceEl.classList.toggle('text-negro-picks', !sale);
        if (compareEl) { compareEl.textContent = sale ? formatMoney(variant.compare_at_price) : ''; compareEl.classList.toggle('hidden', !sale); }
        submit.disabled = !variant.available;
        submitText.textContent = variant.available ? 'Añadir al Carrito' : 'Agotado';
        if (variant.featured_image) setMain(variant.featured_image.src + (variant.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1600');
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });

    var qtyInput = $('[data-ps-qty-input]', root);
    $$('[data-ps-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(b.getAttribute('data-ps-qty')));
        qtyInput.value = v;
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var original = submitText.textContent;
        submit.disabled = true;
        addToCart(idInput.value, qtyInput ? qtyInput.value : 1).then(function () {
          submitText.textContent = '✓ Listo';
          submit.classList.add('bg-naranja-acento');
          showToast('Añadido al carrito: ' + (product ? product.title : ''));
          refreshCartCount();
          setTimeout(function () { submitText.textContent = original; submit.classList.remove('bg-naranja-acento'); submit.disabled = false; }, 1600);
        }).catch(function (err) { showToast(err.message); submit.disabled = false; });
      });
    }
  }

  /* ---------- Pieza destacada: tilt + specs ---------- */
  function initSpotlight() {
    $$('[data-ps-tilt]').forEach(function (card) {
      var sheen = $('[data-ps-sheen]', card);
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = e.clientX - r.left, y = e.clientY - r.top;
        var rx = ((y - r.height / 2) / (r.height / 2)) * -7;
        var ry = ((x - r.width / 2) / (r.width / 2)) * 7;
        card.style.transform = 'rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) scale(1.02)';
        if (sheen) sheen.style.background = 'radial-gradient(circle at ' + (x / r.width * 100) + '% ' + (y / r.height * 100) + '%, rgba(255,255,255,0.22) 0%, transparent 60%)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = 'rotateX(0deg) rotateY(0deg) scale(1)';
        if (sheen) sheen.style.background = '';
      });
    });
    $$('[data-ps-specs]').forEach(function (box) {
      var rows = $$('.spec-row', box);
      rows.forEach(function (row) {
        row.addEventListener('click', function () {
          rows.forEach(function (r) { r.classList.remove('bg-elev-dark-1', 'border-naranja-acento'); });
          row.classList.add('bg-elev-dark-1', 'border-naranja-acento');
        });
      });
    });
  }

  /* ---------- Recomendaciones ---------- */
  function initRecommendations() {
    $$('[data-ps-recommendations]').forEach(function (el) {
      if (el.children.length) return;
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-ps-recommendations]');
        if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; initReveal(); updateFavUI(); }
      }).catch(function () {});
    });
  }

  /* ---------- Cupón en la bolsa ---------- */
  function initDiscount() {
    var btn = $('[data-ps-discount-apply]');
    var input = $('[data-ps-discount-input]');
    if (!btn || !input) return;
    function go() {
      var code = input.value.trim();
      var msg = $('[data-ps-discount-msg]');
      if (!code) { if (msg) { msg.textContent = 'Escribe un código.'; msg.classList.remove('hidden'); } return; }
      window.location.href = rootUrl('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent((PS.routes && PS.routes.cart) || '/cart'));
    }
    btn.addEventListener('click', go);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
  }

  function init() {
    initReveal();
    initMobileMenu();
    $$('[data-ps-filter-scope]').forEach(initFilterScope);
    initFavorites();
    initQuickAdd();
    initQuickView();
    initProduct();
    initSpotlight();
    initRecommendations();
    initDiscount();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  document.addEventListener('shopify:section:load', function (e) {
    initReveal();
    $$('[data-ps-filter-scope]', e.target).forEach(initFilterScope);
    initSpotlight();
    updateFavUI();
  });
})();
